var NO_PROTOCOL_RESOURCE_PATTERN = /^\/\//;

function hasProtocol(uri) {
  return !NO_PROTOCOL_RESOURCE_PATTERN.test(uri);
}

module.exports = hasProtocol;



//////////////////
// WEBPACK FOOTER
// ./~/clean-css/lib/utils/has-protocol.js
// module id = 468
// module chunks = 0